<template>
  <div>
    <el-row>
      <el-date-picker
        v-model="reports_date_range"
        class="float-right"
        type="daterange"
        unlink-panels
        range-separator="-"
        start-placeholder="Start date"
        end-placeholder="End date"
        :picker-options="dateRangeOptions"
        format="d MMMM yyyy"
        value-format="yyyy-MM-dd"
        @change="filter()"
      ></el-date-picker>
    </el-row>
    <el-row>
      <el-col :span="24" :lg="24">
        <h1>License Usage by YouTube category</h1>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" :lg="24">
        <GChart type="PieChart" :data="category_chart" :options="PieChartSett" />
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <h4>
          Number of categories: <span>{{ categories.length }}</span>
        </h4>
        <el-tabs v-model="activeCategories" type="border-card">
          <el-tab-pane label="Collective" name="collective_categories">
            <el-table :data="categories" class="w100" stripe v-loading="loading">
              <el-table-column
                label="Category"
                prop="category_name"
                width="300"
                sortable
              ></el-table-column>
              <el-table-column
                label="No. Videos"
                prop="videos"
                sortable
              ></el-table-column>
              <el-table-column
                label="No. Views"
                prop="views"
                sortable
              ></el-table-column>
              <el-table-column
                label="No. Subscribers"
                prop="subscribers"
                sortable
              ></el-table-column>
              <el-table-column label="Date" prop="date" sortable>
                <template slot-scope="props">
                  {{ props.row.date | date }}
                </template>
              </el-table-column>
              <!-- <el-table-column label="Actions" align="right">
                          <template slot-scope="props">
                            <el-tooltip content="Show charts" placement="left">
                              <el-button
                                type="success"
                                circle
                                size="small"
                                icon="el-icon-s-data"
                                @click="readCategoriesChart(props.row)"
                              ></el-button>
                            </el-tooltip>
                          </template>
                        </el-table-column> -->
            </el-table>
            <!-- <el-pagination
              v-if="categories.next_page_url !== null"
              class="float-right"
              background
              @size-change="sizeChange"
              @current-change="currentChange"
              :current-page.sync="categories.current_page"
              :page-sizes="[5, 10, 25, 50, 100]"
              :page-size="page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="categories.total"
            ></el-pagination> -->
          </el-tab-pane>
          <el-tab-pane label="Daily" name="daily_categories">
            <el-table :data="categories" class="w100" stripe v-loading="loading">
              <el-table-column
                label="Category"
                prop="category_name"
                width="300"
                sortable
              ></el-table-column>
              <el-table-column
                label="No. Daily Videos"
                prop="daily_videos"
                sortable
              ></el-table-column>
              <el-table-column
                label="No. Daily Views"
                prop="daily_views"
                sortable
              ></el-table-column>
              <el-table-column
                label="No. Daily Subscribers"
                prop="daily_subscribers"
                sortable
              ></el-table-column>
              <el-table-column label="Date" prop="date" sortable>
                <template slot-scope="props">
                  {{ props.row.date | date }}
                </template>
              </el-table-column>
            </el-table>
            <!-- <el-pagination
              v-if="categories.next_page_url !== null"
              class="float-right"
              background
              @size-change="sizeChange"
              @current-change="currentChange"
              :current-page.sync="categories.current_page"
              :page-sizes="[5, 10, 25, 50, 100]"
              :page-size="page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="categories.total"
            ></el-pagination> -->
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { GChart } from 'vue-google-charts'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'

export default {
  components: {
    GChart
  },

  data() {
    return {
      reports_date_range: [
        format(subDays(new Date(), 7), 'yyyy-MM-dd'),
        format(addDays(new Date(), 1), 'yyyy-MM-dd')
      ],
      activeCategories: 'collective_categories'
    }
  },

  computed: {
    ...mapState('reportsCategory', [
      'loading',
      'date_range',
      'page',
      'page_size',
      'categories',
      'category_data',
      'PieChartSett'
    ]),

    ...mapGetters('auth', ['admin_role']),
    ...mapGetters('reportsCategory', ['category_chart'])
  },

  methods: {
    ...mapActions('reportsCategory', [
      'readCategoriesChartData',
      'readCategoriesData'
    ]),

    ...mapMutations('reportsCategory', [
      'setDateRange',
      'setPage',
      'setPageSize'
    ]),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readCategoriesData()
    },
    currentChange(page) {
      this.setPage(page)
      this.readCategoriesData()
    },
    filter() {
      this.setDateRange({
        start: this.reports_date_range[0],
        end: this.reports_date_range[1]
      }),
      this.readCategoriesData({
        start: this.reports_date_range[0],
        end: this.reports_date_range[1]
      }),
      this.readCategoriesChartData({
        start: this.reports_date_range[0],
        end: this.reports_date_range[1],
        merge: true,
        charts: true
      })
    }
  },

  created() {
    setTimeout(() => {
      this.filter()
    }, 1000)
  }
}
</script>

<style scoped>
h1 {
  text-align: center;
  font-weight: 200;
  font-size: 1.7rem;
}
.el-row {
  margin-top: 1rem;
}
</style>
